import type { PdfFormField } from "./types";

/** Export options take precedence over generic truthy strings. */
export function isPdfFormCheckboxChecked(field: PdfFormField): boolean {
  const value = field.value;
  if (typeof value === "boolean") return value;
  if (value == null || value === "") return false;
  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return false;
  if (field.options?.length)
    return field.options.some(
      (option) => option.trim().toLowerCase() === normalized
    );
  return ["yes", "true", "1", "on", "checked", "x"].includes(normalized);
}

export function getPdfFormTextValue(field: PdfFormField): string {
  return field.value == null ? "" : String(field.value);
}
